/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AggregatorStore } from '../models/AggregatorStore';
import type { InstrumentationRequestBody } from '../models/InstrumentationRequestBody';
import type { InstrumentationStatus } from '../models/InstrumentationStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class InstrumentationService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @param requestBody
     * @returns InstrumentationStatus successful operation
     * @throws ApiError
     */
    public start(
        requestBody: InstrumentationRequestBody,
    ): CancelablePromise<InstrumentationStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/benchmark/start',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns InstrumentationStatus successful operation
     * @throws ApiError
     */
    public stop(
        requestBody: InstrumentationRequestBody,
    ): CancelablePromise<InstrumentationStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/benchmark/stop',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns InstrumentationStatus successful operation
     * @throws ApiError
     */
    public status(): CancelablePromise<InstrumentationStatus> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/status',
        });
    }

    /**
     * @returns AggregatorStore successful operation
     * @throws ApiError
     */
    public terminate(): CancelablePromise<AggregatorStore> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/terminate',
        });
    }

}
